import { Box, Card, CardFooter, CardHeader } from "@prismicio/editor-ui"
import type { ReactNode } from "react"

interface ReleasePageHeaderProps {
  title: ReactNode
  actions: ReactNode
  footer?: ReactNode
}

export function ReleasePageHeader(props: ReleasePageHeaderProps) {
  const { actions, footer, title } = props

  return (
    <Card paddingBlock={28} paddingInline={24}>
      <CardHeader>
        <Box gap={4} alignItems="center" padding={{ right: 8 }} flexGrow={1}>
          {title}
        </Box>

        {actions}
      </CardHeader>
      {footer && <CardFooter>{footer}</CardFooter>}
    </Card>
  )
}
